<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="业务号">
              <div class="custom-select-container">
                <a-input
                  allow-clear
                  placeholder="请输入"
                  v-model="queryParam.business_no"
                >
                </a-input>
              </div>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="24">
            <a-form-item label="采销全流程">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                allow-clear
                v-model="queryParam.project_id"
                placeholder="请输入名称"
                :default-active-first-option="false"
                @search="this.projectSearch"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id" :tt="d.name">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="发票类型">
              <div class="custom-select-container">
                <a-select
                  allow-clear
                  placeholder="请选择"
                  v-model="queryParam.invoice_type"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_invoice_type">{{ val }}</a-select-option>
                </a-select>
              </div>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="false">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleArchived">批量存档</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="true">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1200 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="approval_needed" slot-scope="text, record">
        <a-popconfirm
          title="确定开启审批吗?"
          :disabled="text"
          @confirm="() => approvalNeeded(record, undefined, false)">
          <a-switch checked-children="是" un-checked-children="否" :checked="record.is_approval_needed" :disabled="record.is_approval_needed"/>
        </a-popconfirm>
      </span>
      <div slot="money_render" slot-scope="text" style="text-align: right; min-width: 90px; max-width: 200px">
        {{ (text / 1).toFixed(4) | numberFormat }}
      </div>
      <div slot="recipient_corporation" slot-scope="text, record" style="text-align: right; min-width: 90px; max-width: 200px">
        <a-popover>
          <template slot="content">
            <a-descriptions title="收票主体信息" style="width: 900px">
              <a-descriptions-item label="纳税人识别号" v-if="record.taxpayer_identification_number">
                {{ record.taxpayer_identification_number }}
              </a-descriptions-item>
              <a-descriptions-item label="地址" v-if="record.address">
                {{ record.address }}
              </a-descriptions-item>
              <a-descriptions-item label="电话" v-if="record.phone">
                {{ record.phone }}
              </a-descriptions-item>
              <a-descriptions-item label="开户行" v-if="record.bank_name">
                {{ record.bank_name }}
              </a-descriptions-item>
              <a-descriptions-item label="账号" v-if="record.bank_account">
                {{ record.bank_account }}
              </a-descriptions-item>
            </a-descriptions>
          </template>
          <a> {{ text }}</a>
        </a-popover>
      </div>
      <span slot="archived" slot-scope="text, item">
        <a-popconfirm
          title="确定存档吗?"
          :disabled="text"
          @confirm="() => archived(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
        </a-popconfirm>
      </span>
      <span slot="invoiced" slot-scope="text, item">
        <a-popconfirm
          title="确定已开票吗?"
          :disabled="text"
          @confirm="() => invoiced(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_invoiced" :disabled="item.is_invoiced"/>
        </a-popconfirm>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <!--          <a @click="handleDetail(record)">明细</a>-->
          <!--          <a-divider type="vertical" />-->
          <a @click="handleAddInvoice(record)" v-if="record.is_invoiced">发票信息</a>
          <!--          <a-divider type="vertical" v-if="record.is_invoiced"/>-->
          <!--          <a @click="handleAttachment(record)">附件</a>-->
          <!--          <a-divider type="vertical" v-if="record.is_invoiced"/>-->
          <a @click="handleEdit(record)" v-if="!record.is_invoiced && isEdited(record.create_by_id)">编辑</a>
          <a-divider type="vertical" v-if="!record.is_invoiced && isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="!record.is_invoiced && isEdited(record.create_by_id)"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="record.is_approval_needed && record.status === 3 && isEdited(record.create_by_id)"
            title="确定重启审批?"
            @confirm="() => approvalNeeded(record, 'fapiao', true)">
            <span>重启审批</span>
          </a-popconfirm>
          <a-divider type="vertical" v-if="isPushJd(record)"/>
          <a-popconfirm
            v-if="isPushJd(record)"
            title="确定推送金蝶?"
            @confirm="() => handlePushJd(record)">
            <a>推送金蝶</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <archived-form
      ref="archivedModal"
      :visible="archived_visible"
      @cancel="handleArchivedCancel"
      @ok="handleArchivedOK"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import CreateForm from '../modules/CreateForm'
import ArchivedForm from '../modules/ArchivedForm'
import {
  fapiao_list,
  fapiao_create,
  fapiao_delete,
  fapiao_archived,
  fapiao_update,
  fapiao_to_jd
} from '@/api/trade_fapiao'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm,
    ArchivedForm
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archived_visible: false,
      projectFetching: false,
      mdl: {},
      projectList: [],
      clientList: [],
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '业务号',
          dataIndex: 'business_no',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '采销全流程',
          dataIndex: 'project',
          width: 150,
          ellipsis: true
        },
        {
          title: '合同号',
          dataIndex: 'contract_number',
          width: 180,
          ellipsis: true
        },
        {
          title: '合同类型',
          dataIndex: 'invoice_contract_type',
          width: 150,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.trade_invoice_contract_type[text] || '无'
        },
        {
          title: '开票主体',
          dataIndex: 'invoice_issuer_corporation',
          width: 150,
          ellipsis: true
        },
        {
          title: '发票类型',
          dataIndex: 'invoice_type',
          ellipsis: true,
          align: 'center',
          width: 150,
          customRender: (text) => this.$Dictionaries.trade_invoice_type[text] || '无'
        },
        {
          title: '发票名称',
          dataIndex: 'invoice_name',
          width: 150,
          ellipsis: true
        },
        {
          title: '发票数量',
          dataIndex: 'invoice_quantity',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '发票金额',
          dataIndex: 'invoice_amount',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '收票主体',
          dataIndex: 'recipient_corporation',
          width: 200,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'recipient_corporation' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 150,
          ellipsis: true
        },
        {
          title: '已开票',
          dataIndex: 'is_invoiced',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'invoiced' }
        },
        {
          title: '开启审批',
          dataIndex: 'is_approval_needed',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'approval_needed' }
        },
        {
          title: '审批状态',
          dataIndex: 'status',
          align: 'center',
          width: 100,
          customRender: (text, record) => record.is_approval_needed ? this.$Dictionaries.approval_result[text] : '未开启审批'
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 180,
          ellipsis: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '210px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData.parameter', parameter)
        return fapiao_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    if (this.$route.query && this.$route.query.id) {
      this.queryParam['id'] = this.$route.query.id
    }
  },
  computed: {
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    },
    isPushJd () {
      return (record) => {
        return record.invoice_contract_type === 1 && record.is_invoiced && record.is_approval_needed && record.status === 2 && this.isEdited(record.create_by_id)
      }
    }
  },
  methods: {
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      // const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      // const second = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
      this.mdl = { business_no: year + '' + month + '' + day + '' + hours }
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archived_visible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archived_visible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleAttachment (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/fapiao/' + record.id + '/attachment', query: { project: record.project, client: record.client } })
    },
    handleEdit (record) {
      this.$router.push({ path: '/trade/fapiao/' + record.id })
    },
    handleDetail (record) {
      this.$router.push({ path: '/trade/fapiao/' + record.id + '/fapiao_detail_list', query: { project: record.project, client: record.client } })
    },
    handleAddInvoice (record) {
      this.$router.push({ path: '/trade/fapiao/' + record.id + '/fapiao_detail_list', query: { project: record.project, invoice_name: record.invoice_name } })
    },
    handlePushJd (record) {
      this.loading = true
      fapiao_to_jd({ id: record.id }).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    approvalNeeded (record, type, approval_again) {
      const is_approval_needed = approval_again ? true : !record.is_approval_needed
      if (is_approval_needed) {
        this.loading = true
        fapiao_update({ is_approval_needed: is_approval_needed }, record.id).then(res => {
          if (res.code === 1000) {
            this.$refs.table.refresh()
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    archived (record) {
      fapiao_archived({ id: record.id, is_archived: !record.is_archived }).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    invoiced (record) {
      fapiao_update({ is_invoiced: !record.is_invoiced }, record.id).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleDelete (record) {
      fapiao_delete(record.id).then((res) => {
        console.log(res)
        if (res.code === 1000) {
          console.log('删除成功------')
          this.$refs.table.refresh()
        }
      })
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
            // 新增
          values = { ...values, ...data }
          values['contract_type'] = values['contract_type'].join(',')
          fapiao_create(values).then(res => {
              this.visible = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleProjectSearch (value) {
      if (value === undefined || value === '') {
        return
      }
      this.projectFetching = true
      this.projectList = []
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleArchivedOK () {
      const form = this.$refs.archivedModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const data = {
            ids: this.selectedRowKeys,
            ...values
          }
          fapiao_archived(data).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.archived_visible = false
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
